import { useEffect } from 'react'
import { useActiveLessonStore } from '@/stores/activeLessonStore'

/**
 * Синхронизация глобальной плашки текущего урока: запрос при появлении
 * авторизованного пользователя, сброс при выходе и при смене пользователя
 * (в том числе при входе админа под другим аккаунтом), чтобы урок прежнего
 * пользователя не мелькнул.
 */
export function useActiveLessonSync(userId: number | null): void {
  const fetchActiveLesson = useActiveLessonStore((state) => state.fetch)
  const reset = useActiveLessonStore((state) => state.reset)

  useEffect(() => {
    if (!userId) return
    void fetchActiveLesson()
    return () => reset()
  }, [fetchActiveLesson, reset, userId])
}
